<template>
  <div id="app">
    <vk-grid gutter="collapse" id="grid">
      <div class="uk-width-medium" id="nav">
        <div id="nav-banner">
          IOL Panel
        </div>
        
        <router-link v-if="!isLogged" to="/login"><div class="nav-link"><vk-icon icon="user"/> Login</div></router-link>

        <router-link v-if="isLogged" to="/"><div class="nav-link"><vk-icon icon="world"/> Mappa</div></router-link>
        <router-link v-if="isLogged" to="/tableview"><div class="nav-link"><vk-icon icon="list"/> Tabulato</div></router-link>
        <router-link v-if="isLogged" to="/graphview"><div class="nav-link"><vk-icon icon="image"/> Grafico</div></router-link>
        <router-link v-if="isLogged" to="/csv"><div class="nav-link"><vk-icon icon="download"/> CSV</div></router-link>
        <router-link v-if="isLogged" to="/commands"><div class="nav-link"><vk-icon icon="settings"/> Comandi</div></router-link>
        <router-link v-if="isLogged && isAdmin" to="/manageusers"><div class="nav-link"><vk-icon icon="cog"/> Gestione utenti</div></router-link>
        <router-link v-if="isLogged && isAdmin" to="/managedevices"><div class="nav-link"><vk-icon icon="cog"/> Gestione device</div></router-link>
        <router-link v-if="isLogged" to="/account"><div class="nav-link"><vk-icon icon="user"/> Account</div></router-link>

        <router-link to="/about"><div class="nav-link"><vk-icon icon="info"/> Informazioni su</div></router-link>

        <vk-card v-if="isLogged && $route.meta.needsQueryForm == true" type="secondary" padding="small">
          <div class="uk-margin">
            <div class="refreshing-notice" v-if="$store.state.queryRunning">Aggiornamento...</div>
            <vk-button v-bind:class="{ 'orange-button': queryChangedFlag }" size="small" @click="refreshQuery" v-else><vk-icon icon="refresh"></vk-icon> Aggiorna</vk-button>
          </div>

          <QueryForm @input="queryChanged" :showQuickFilters="true"/>
        </vk-card>
      </div>
      <div class="uk-width-expand">
        <router-view/>
      </div>
    </vk-grid>
  </div>
</template>

<script>
import QueryForm from '@/components/QueryForm.vue'
import { mapState } from 'vuex'
import { arraySetsEqual } from '@/utils'

export default {
  name: 'App',

  components: { QueryForm },

  data () {
    return {
      currentQuery: {
        from: 0,
        to: 0,
        deviceFilter: []
      },
      queryChangedFlag: false
    }
  },

  computed: {
    ...mapState(['isLogged', 'isAdmin', 'queryLastResult'])
  },

  watch: {
    queryLastResult () {
      this.queryChangedFlag = false
    }
  },

  created () {
    this.$store.dispatch('REFRESH_USER_DEVICES', this.$http)
  },

  methods: {
    queryChanged (query) {
      if (
        !arraySetsEqual(query.deviceFilter, this.$store.state.queryLastParam.deviceFilter) ||
        query.from != this.$store.state.queryLastParam.from ||
        query.to != this.$store.state.queryLastParam.to
      ) {
        this.queryChangedFlag = true
      }

      this.currentQuery = query
    },

    refreshQuery () {
      this.$store.dispatch('RUN_QUERY', {
        http: this.$http,
        query: this.currentQuery
      })
    }
  }
}
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;

    width: 100%;
    height: 100%;
  }

  #grid {
    height: 100%;
    width: 100%;
  }

  #nav {
    text-align: center;

    #nav-banner {
      height: 3em;
      line-height: 3em;
      color: white;
      font-weight: bold;
      font-size: 1.3em;
      background-color: #1e87f0;
      width: 100%;
    }

    a {
      font-weight: bold;
      color: #2c3e50;
      text-decoration:none !important;
    }

    a.router-link-exact-active {
      color: #283593;
    }
  }

  .nav-link {
    width: 100%;
    height: 3em;
    line-height: 3em;
    border-bottom: 1px dashed #888;

    text-decoration:none !important;
  }

  .nav-link:hover {
    background-color: #DDD;
  }

  .refreshing-notice {
    border: 1px solid white;
    padding-left: 0.5em;
    padding-right: 0.5em;
    color: white;
    text-align: center;
    line-height: 28px;
    background-color: rgba(100, 255, 100, 0.5)
  }
  
  .orange-button {
    background-color: rgba(200, 150, 10, 1.0) !important;
  }
</style>
